const versionPollingIntervalMinutes = 10;
export const durationBeforeMandatoryRefreshMinutes = 5;

export const pollIntervalMs = versionPollingIntervalMinutes * 60 * 1000;
